import { fromTheme as kyruusFromTheme } from '@kyruus/ui-theme';

/**
 * Builds the palette configuration for the MUI theme based on Kyruus theme values.
 * @param {object} kyruusTheme - The Kyruus theme object
 * @returns {object} The palette configuration for MUI theme
 */
export const buildPalette = (kyruusTheme: Record<string, unknown>) => {
  // wrap fromTheme to simplify the code below
  const fromTheme = (themeKey: string) =>
    kyruusFromTheme(themeKey)({ theme: kyruusTheme });

  const colorProvidermatch = fromTheme('color_providermatch');
  const colorSuccess = fromTheme('color_success');
  const colorInfo = fromTheme('color_info');
  const colorWarning = fromTheme('color_warning');
  const colorDanger = fromTheme('color_danger');

  const colorProvidermatchSecondary = fromTheme(
    'color_providermatch_secondary'
  );
  const colorSuccessSecondary = fromTheme('color_success_secondary');
  const colorInfoSecondary = fromTheme('color_info_secondary');
  const colorWarningSecondary = fromTheme('color_warning_secondary');
  const colorDangerSecondary = fromTheme('color_danger_secondary');

  const colorBackground = fromTheme('color_background');
  const colorBackgroundDanger = fromTheme('color_background_danger');
  const colorBackgroundInfo = fromTheme('color_background_info');
  const colorBackgroundSecondary = fromTheme('color_background_secondary');
  const colorBackgroundSuccess = fromTheme('color_background_success');
  const colorBackgroundWarning = fromTheme('color_background_warning');

  const fontColor = fromTheme('color_text');
  const fontColorSecondary = fromTheme('color_text_secondary');
  const fontColorDisabled = fromTheme('color_text_disabled');

  return {
    primary: {
      main: colorProvidermatch,
      50: colorProvidermatchSecondary,
      100: colorProvidermatchSecondary,
      200: colorProvidermatch,
      300: colorProvidermatch,
      400: colorProvidermatch,
      500: colorProvidermatch,
      600: colorProvidermatch,
      700: colorProvidermatch,
      800: colorProvidermatch,
      900: colorProvidermatch,
      A100: colorProvidermatchSecondary,
      A200: colorProvidermatch,
      A400: colorProvidermatch,
      A700: colorProvidermatch,
      contrastDefaultColor: 'light'
    },
    secondary: {
      main: colorProvidermatchSecondary,
      50: colorProvidermatchSecondary,
      100: colorProvidermatchSecondary,
      200: colorProvidermatch,
      300: colorProvidermatch,
      400: colorProvidermatch,
      500: colorProvidermatch,
      600: colorProvidermatch,
      700: colorProvidermatch,
      800: colorProvidermatch,
      900: colorProvidermatch,
      A100: colorProvidermatchSecondary,
      A200: colorProvidermatch,
      A400: colorProvidermatch,
      A700: colorProvidermatch,
      contrastDefaultColor: 'light'
    },
    success: {
      main: colorSuccess,
      50: colorSuccessSecondary,
      100: colorSuccessSecondary,
      200: colorSuccess,
      300: colorSuccess,
      400: colorSuccess,
      500: colorSuccess,
      600: colorSuccess,
      700: colorSuccess,
      800: colorSuccess,
      900: colorSuccess,
      A100: colorSuccessSecondary,
      A200: colorSuccess,
      A400: colorSuccess,
      A700: colorSuccess,
      contrastDefaultColor: 'light'
    },
    info: {
      main: colorInfo,
      50: colorInfoSecondary,
      100: colorInfoSecondary,
      200: colorInfo,
      300: colorInfo,
      400: colorInfo,
      500: colorInfo,
      600: colorInfo,
      700: colorInfo,
      800: colorInfo,
      900: colorInfo,
      A100: colorInfoSecondary,
      A200: colorInfo,
      A400: colorInfo,
      A700: colorInfo,
      contrastDefaultColor: 'light'
    },
    warning: {
      main: colorWarning,
      50: colorWarningSecondary,
      100: colorWarningSecondary,
      200: colorWarning,
      300: colorWarning,
      400: colorWarning,
      500: colorWarning,
      600: colorWarning,
      700: colorWarning,
      800: colorWarning,
      900: colorWarning,
      A100: colorWarningSecondary,
      A200: colorWarning,
      A400: colorWarning,
      A700: colorWarning,
      contrastDefaultColor: 'light'
    },
    error: {
      main: colorDanger,
      50: colorDangerSecondary,
      100: colorDangerSecondary,
      200: colorDanger,
      300: colorDanger,
      400: colorDanger,
      500: colorDanger,
      600: colorDanger,
      700: colorDanger,
      800: colorDanger,
      900: colorDanger,
      A100: colorDangerSecondary,
      A200: colorDanger,
      A400: colorDanger,
      A700: colorDanger,
      contrastDefaultColor: 'light'
    },
    background: {
      default: colorBackground,
      paper: colorBackgroundSecondary,
      danger: colorBackgroundDanger,
      info: colorBackgroundInfo,
      success: colorBackgroundSuccess,
      warning: colorBackgroundWarning
    },
    text: {
      primary: fontColor,
      secondary: fontColorSecondary,
      disabled: fontColorDisabled
    }
  };
};
